import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import Pagination from "components/navigation/Pagination";
import SitesHeader from "components/sites/SitesHeader";
import { Box } from "components/ui";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { useGetOrderQuery } from "store/abcoApi";
import OrdersTable from "../../../../../../components/orders/OrdersTable";
import PageLoader from "components/general/PageLoader";

export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const { id: siteId } = useLocalSearchParams<{ id: string }>();

	if (!siteId) {
		throw new Error("siteId is required");
	}
	const {
		data: orderData,
		isLoading,
		isFetching,
		isError,
		error,
		currentData,
	} = useGetOrderQuery({
		pageNumber,
		siteIdCollection: [Number(siteId)],
	});

	return (
		<ScrollContainer>
			<SitesHeader />
			<Box paddingVertical={24} bg="$neutral25">
				<Container>
					<Box paddingVertical={24}>
						{(isLoading || isFetching) && (
							<Box minHeight={150}>
								<PageLoader />
							</Box>
						)}
						{orderData?.list && orderData?.list.length > 0 && (
							<>
								<OrdersTable dataList={orderData?.list} />
								<Box justifyContent="center" marginTop={30} alignItems="center">
									<Pagination pageCount={orderData?.metaData?.pageCount} pageNumber={orderData?.metaData?.pageNumber} onChangePage={setPageNumber} />
								</Box>
							</>
						)}
					</Box>
				</Container>
			</Box>
		</ScrollContainer>
	);
}
